import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthContext } from '../contexts/AuthContext'
import HomePage from '../pages/HomePage'
import RegisterPage from '../pages/RegisterPage'
import GamesPage from '../pages/GamesPage'
import GuessNumberPage from '../pages/GuessNumberPage'
import MorseCodePage from '../pages/MorseCodePage'
import LuckyNumbersPage from '../pages/LuckyNumbersPage'
import AirdropPage from '../pages/AirdropPage'
import GiftCardPage from '../pages/GiftCardPage'
import AdminPage from '../pages/AdminPage'
import ProfilePage from '../pages/ProfilePage'
import TopUsersPage from '../pages/TopUsersPage'
import FootballPage from '../pages/FootballPage'
import HorsePage from '../pages/HorsePage'
import DreamTeamBuilderPage from '../pages/DreamTeamBuilderPage'
import FantasyTeamBuilderPage from '../pages/FantasyTeamBuilderPage'
import FantasyTeamVotingPage from '../pages/FantasyTeamVotingPage'
import FantasyExplorePage from '../pages/FantasyExplorePage'
import DreamTeamExplorePage from '../pages/DreamTeamExplorePage'
import DreamTeamViewPage from '../pages/DreamTeamViewPage'
import WalletPage from '../pages/WalletPage'
import CashOutPage from '../pages/CashOutPage'
import SupportPage from '../pages/SupportPage'
import Navigation from '../components/layout/Navigation'
import ToastContainer from '../components/ui/Toast'
import DeepLinkRedirect from '../components/DeepLinkRedirect'
import { useT } from '../contexts/LocaleContext'

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated, isLoading: loading, checkAndLoadUser } = useAuthContext()
  const t = useT()

  useEffect(() => {
    checkAndLoadUser()
  }, [checkAndLoadUser])

  if (loading) {
    return <div className="lucky-boot">{t('common.loading')}</div>
  }

  if (!isAuthenticated) {
    return <Navigate to="/register" replace />
  }

  return <>{children}</>
}

function FantasyTeamBuilderRoute() {
  const { matchId } = useParams<{ matchId: string }>()
  return <ProtectedRoute><FantasyTeamBuilderPage matchId={Number(matchId) || 0} /></ProtectedRoute>
}

function DreamTeamBuilderRoute() {
  const { matchId } = useParams<{ matchId: string }>()
  return <ProtectedRoute><DreamTeamBuilderPage matchId={Number(matchId) || 0} /></ProtectedRoute>
}

export default function App() {
  const { isAuthenticated } = useAuthContext()

  return (
    <div className="mini-app-container">
      <ToastContainer />
      <DeepLinkRedirect />
      <Routes>
        <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/games" element={<ProtectedRoute><GamesPage /></ProtectedRoute>} />
        <Route path="/games/guess-number/play" element={<ProtectedRoute><GuessNumberPage /></ProtectedRoute>} />
        <Route path="/games/morse/play" element={<ProtectedRoute><MorseCodePage /></ProtectedRoute>} />
        <Route path="/games/lucky-numbers/play" element={<ProtectedRoute><LuckyNumbersPage /></ProtectedRoute>} />
        <Route path="/airdrop" element={<ProtectedRoute><AirdropPage /></ProtectedRoute>} />
        <Route path="/gift-card" element={<ProtectedRoute><GiftCardPage /></ProtectedRoute>} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin-panel" element={<AdminPage />} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/top-users" element={<ProtectedRoute><TopUsersPage /></ProtectedRoute>} />
        <Route path="/football" element={<ProtectedRoute><FootballPage /></ProtectedRoute>} />
        <Route path="/horse" element={<ProtectedRoute><HorsePage /></ProtectedRoute>} />
        <Route path="/football/dream-teams/explore" element={<ProtectedRoute><DreamTeamExplorePage /></ProtectedRoute>} />
        <Route path="/football/dream-teams/:teamId" element={<ProtectedRoute><DreamTeamViewPage /></ProtectedRoute>} />
        <Route path="/football/dream-team/:matchId" element={<DreamTeamBuilderRoute />} />
        <Route path="/fantasy/explore" element={<ProtectedRoute><FantasyExplorePage /></ProtectedRoute>} />
        <Route path="/fantasy/:matchId" element={<FantasyTeamBuilderRoute />} />
        <Route path="/fantasy/vote" element={<FantasyTeamVotingPage />} />
        <Route path="/wallet" element={<ProtectedRoute><WalletPage /></ProtectedRoute>} />
        <Route path="/cash-out" element={<ProtectedRoute><CashOutPage /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {isAuthenticated && <Navigation />}
    </div>
  )
}